import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { fmtRM, fmtNum } from "../../lib/format";
import { PageTitle, Spinner } from "../../components/Shell";

const Box = ({ title, rows }) => (
  <div className="bg-card rounded-xl border border-brand-deep/10 p-5">
    <h3 className="font-display font-semibold text-brand-dark mb-4">{title}</h3>
    <div className="space-y-2.5">
      {rows.map(([label, value, money]) => (
        <div key={label} className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground capitalize">{label || "-"}</span>
          <span className="font-mono font-semibold text-brand-dark">{money ? fmtRM(value) : fmtNum(value)}</span>
        </div>
      ))}
    </div>
  </div>
);

export default function Reports() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/tenant/reports/summary").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <Spinner />;

  return (
    <div data-testid="tenant-reports">
      <PageTitle title="Laporan" sub="Ringkasan ahli, kewangan dan kutipan" />
      <div className="grid sm:grid-cols-2 gap-4">
        <Box title="Ahli mengikut Status" rows={data.members_by_status.map((r) => [r._id, r.count])} />
        <Box title="Ahli mengikut KYC" rows={data.members_by_kyc.map((r) => [r._id, r.count])} />
        <Box title="Yuran mengikut Status" rows={data.fees_by_status.map((r) => [`${r._id} (${r.count})`, r.amount, true])} />
        <Box title="Kutipan mengikut Kaedah" rows={data.payments_by_method.map((r) => [r._id, r.total, true])} />
      </div>
      <div className="mt-4 bg-card rounded-xl border border-brand-deep/10 p-5">
        <h3 className="font-display font-semibold text-brand-dark mb-4">Pemegang Saham Tertinggi</h3>
        <div className="space-y-2.5">
          {data.top_members.map((m, i) => (
            <div key={m.member_no} className="flex items-center gap-3 text-sm">
              <span className="w-6 h-6 rounded-full bg-gold-light text-gold text-xs font-bold flex items-center justify-center">{i + 1}</span>
              <span className="font-mono text-xs text-brand-deep">{m.member_no}</span>
              <span className="flex-1 font-medium text-brand-dark truncate">{m.name}</span>
              <span className="font-mono font-semibold">{fmtRM(m.share_balance)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
